const border = "1px solid #666";
const backgroundColor = "hsla(250, 86%, 97%, 1)";
const fontSize = "14px";
const pt = 1.5;

export const fullHeadBorder = {
  muiTableHeadCellProps: {
    align: "center",
    sx: {
      border,
      backgroundColor,
      fontSize,
      pt,
    },
  },
};
export const rightBorder = {
  muiTableHeadCellProps: {
    sx: {
      borderRight: border,
      backgroundColor,
      borderLeft: "1px solid rgba(224,224,224,1)",
    },
  },
  muiTableBodyCellProps: {
    sx: {
      borderRight: border,
      borderLeft: "1px solid rgba(224,224,224,1)",
    },
  },
};

export const leftBorder = {
  muiTableHeadCellProps: {
    sx: {
      borderLeft: border,
      backgroundColor,
      borderRight: "1px solid rgba(224,224,224,1)",
    },
  },
  muiTableBodyCellProps: {
    sx: {
      borderLeft: border,
      borderRight: "1px solid rgba(224,224,224,1)",
    },
  },
};
